import { gql } from 'graphql-tag';
import { CatalogItemCardFragment } from '../fragments/fragments.cartEndpoint';

const GetMobileMenuTreeFragment = gql`
  fragment GetMobileMenuTreeFragment on CatalogTypesModel {
    id
    title
    identify
    active
    menu_type
    is_menu
    totalProducts: rubticProductsCount
    fileItem {
      tempFullFilePath
      cacheItem {
        filePath
      }
    }
    is_not_for_sale
    childrenItems {
      id
      title: shortTitle
      identify
      rubticProductsCount
      childrenItems {
        id
        title
        identify
        rubticProductsCount
      }
    }
    rubticProductsCount
    rubricGroupTitle
    rubricGroup {
      id
      title
      identify
      rubticProductsCount
    }
  }
`;

const CatalogQuery = {
  getTopMenu: gql`
    query getTopMenu {
      getTopMenu {
        id
        className
        title
        link
        icon
        icon_2x
        icon_3x
      }
    }
  `,
  getBarMenuCategories: gql`
    query getBarMenuCategories(
      $device: String
      $withChildren: Boolean
      $menuStoreId: Int
    ) {
      getMobileMenuTree(
        device: $device
        withChildren: $withChildren
        isMenu: true
        menuStoreId: $menuStoreId
      ) {
        ...GetMobileMenuTreeFragment
        bg_color
        badge_text
      }
    }
    ${GetMobileMenuTreeFragment}
  `,
  getBarMenuTypes: gql`
    query barTypes($menuStoreId: Int) {
      getBarMenuTypes(menuStoreId: $menuStoreId) {
        id
        identify
        name
        file_url
        icon_url
        active
        weight
        catalogTypes {
          id
          identify
          active
          menu_type
          is_menu
          totalProducts: rubticProductsCount
        }
      }
    }
  `,
  getMobileMenuTree: gql`
    query getMobileMenuTree(
      $device: String
      $menuTypeId: String
      $withChildren: Boolean
      $isMenu: Boolean
      $is18plus: Boolean
      $menuStoreId: Int
    ) {
      getMobileMenuTree(
        device: $device
        menuTypeId: $menuTypeId
        withChildren: $withChildren
        isMenu: $isMenu
        is18plus: $is18plus
        menuStoreId: $menuStoreId
      ) {
        ...GetMobileMenuTreeFragment
      }
      getMenuSpecial {
        id
        title
        title_color
        link
        image
        active
        sort
      }
      getChefCatalogRubrics: getProducts(
        type: "ot-shefa"
        setOrder: "popular"
      ) {
        rubricMenuTree {
          id
          title
          identify
          rubticProductsCount
        }
      }
      getPromoCatalogRubrics: getProducts(specOffer: "promo") {
        rubricMenuTree {
          id
          rubticProductsCount
          title
          identify
          short_title
          shortTitle
        }
      }
    }
    ${GetMobileMenuTreeFragment}
  `,
  getPromoMenu: gql`
    query getPromoMenu($type: String, $specOffer: String) {
      getProducts(type: $type, specOffer: $specOffer) {
        rubricMenuTree {
          id
          title
          identify
          short_title
          shortTitle
        }
      }
    }
  `,
  getCatalogList: gql`
    query getCatalogList {
      getCatalogMainMenu(imageSizeFilter: "80") {
        id
        identify
        title
        fileItem {
          cacheItem {
            filePath
          }
        }
      }
    }
  `,
  getRubricBanners: gql`
    query getRubricBanners($type: String, $setLimit: Int) {
      getRubricBanners(type: $type, setLimit: $setLimit) {
        id
        title
        product_title
        link
        file_new
        bannerFilePath
        fileItem {
          cacheItem {
            filePath
          }
        }
        catalogItems {
          id
          title
          oldPrice
          price
          discounPriceField
          discounPriceField2
          currentPriceField
          currentPriceField2
          oldPriceField
          oldPriceField2
          priceBlockWeightPrice
          specialPriceData {
            price1Kg
            price
            amount
          }

          measureItem {
            weight
            symbol
          }
        }
      }
    }
  `,
  getBannerAndText: gql`
    query getBannerAndText(
      $page: Int
      $setLimit: Int
      $setOrder: String
      $type: String
      $group: String
      $specOfferFirst: Boolean
      $specOffer: String
    ) {
      getProducts(
        page: $page
        setLimit: $setLimit
        setOrder: $setOrder
        type: $type
        group: $group
        specOfferFirst: $specOfferFirst
        specOffer: $specOffer
      ) {
        rubricBanner
        rubricText
        rubricBigCards
        rubricBreadcrumbs {
          title
          id
          identify
        }
        popularCatalogItems {
          ...CatalogItemCardFragment
        }
      }
    }
    ${CatalogItemCardFragment}
  `,

  getPopularMainPageItems: gql`
    query getPopularMainPageItems {
      getPopularMainPageItems {
        ...CatalogItemCardFragment
      }
    }
    ${CatalogItemCardFragment}
  `,
  getRecipesRecommend: gql`
    query getRecipesRecommend {
      getRecipesRecommend {
        id
        title
        identifyIdURI
        cooking_time
        recipes_difficult
        rating
        text
        serving
        date
        viewCount
        comments_number
        calories
        protein
        fat
        carbohydrates
        attachmentsItem {
          cacheItem {
            filePath
          }
        }
        authorItem {
          identify
          title
          fio
          userItem {
            attachmentsItem {
              tempFullFilePath
            }
          }
        }
      }
    }
  `,

  getProducts: gql`
    query getProducts(
      $offset: Int
      $page: Int
      $setLimit: Int
      $setOrder: String
      $type: String
      $group: String
      $isExpress: Boolean
      $specOfferFirst: Boolean
      $specOffer: String
      $groups: [String!]
      $menuStoreId: Int
    ) {
      getProducts(
        offset: $offset
        page: $page
        setLimit: $setLimit
        setOrder: $setOrder
        type: $type
        group: $group
        specOfferFirst: $specOfferFirst
        specOffer: $specOffer
        groups: $groups
        menuStoreId: $menuStoreId
        isExpress: $isExpress
      ) {
        catalogItems {
          ...CatalogItemCardFragment
        }
        catalogSeo {
          highPrice
          lowPrice
          reviewCount
          ratingValue
          offerCount
        }
        totalCount
        rubricTitle
        rubricParentIdentify
        rubricMenuTree {
          id
          title
          identify
          short_title
          shortTitle
          children {
            id
            title
            identify
            short_title
            shortTitle
            rubticProductsCount
          }
        }
        rubricParentItem {
          id
          title
          identify
        }
        rubricGroupTitle
        rubricGroup {
          id
          identify
          title
          short_title
        }
        rubricTypesTile
        rubricTypes {
          id
          identify
          title
          short_title
          shortTitle
        }
      }
    }
    ${CatalogItemCardFragment}
  `,
  getBarMenuProducts: gql`
    query getBarMenuProducts($menuStoreId: Int, $setLimit: Int) {
      getProducts(menuStoreId: $menuStoreId, setLimit: $setLimit) {
        catalogItems {
          ...CatalogItemCardFragment
          relType {
            type_id
          }
        }
      }
    }
    ${CatalogItemCardFragment}
  `,
  isProductHasAttachmentInComments: gql`
    query isProductHasAttachmentInComments($catalogId: Float!) {
      isProductHasAttachmentInComments(catalogId: $catalogId)
    }
  `,
  getCartShareData: gql`
    query getCartShareData($cartShareLink: String) {
      getCartShareData(cartShareLink: $cartShareLink) {
        cartToken
        id
        cartItems {
          catalog_id
          amount
          catalogItem {
            id
            title
          }
        }
      }
    }
  `,
  queryCatalogFaq: gql`
    query queryCatalogFaq($url: String!) {
      queryCatalogFaq(url: $url) {
        title
        answer
      }
    }
  `,
  getProductsBySearchBooster: gql`
    query getProductsBySearchBooster(
      $isFullSearch: Boolean
      $filters: AppliedFilters
      $orderDir: OrderDir
      $orderBy: ProductSort
      $userInput: String
      $productsSize: AppliedFilters
      $categories: [Int!]
    ) {
      getProductsBySearchBooster(
        isFullSearch: $isFullSearch
        filters: $filters
        orderDir: $orderDir
        orderBy: $orderBy
        userInput: $userInput
        productsSize: $productsSize
        categories: $categories
      ) {
        redirect
        minPrice
        maxPrice
        availableFilters {
          highRating
          discount
          newbee
          reviewed
          hits
          maxPrice
          minPrice
        }
        tips {
          label
          query
        }
        categories {
          id
          name
          hits
        }
        catalogItems {
          ...CatalogItemCardFragment
        }
        noExactProductFound
      }
    }
    ${CatalogItemCardFragment}
  `
};

export default CatalogQuery;
